import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/acceptInvite';

export const ACCEPT_INVITE = defineAsyncActionTypes(`${prefix}/ACCEPT_INVITE`);
